/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetIdentityCheckRow } from '../openapi-types.gen.js';
import { type useGetIdentityCheckArgs, useGetIdentityCheckSpec } from '../specs/auth.spec.gen.js';

export type { GetIdentityCheckRow } from '../openapi-types.gen.js';
export type { useGetIdentityCheckArgs } from '../specs/auth.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): kind, email, provider, providerUserId, handle.
 */
export const useGetIdentityCheck = createHook(useGetIdentityCheckSpec);


/**
 * Hover/intent prefetch companion for `useGetIdentityCheck`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetIdentityCheck();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetIdentityCheck = createPrefetchHook(useGetIdentityCheckSpec);
